import { ethers } from "ethers";

export const CHAIN_HEX = "0x38"; // BSC mainnet (56)

export const ERC20_ABI = [
  "function balanceOf(address) view returns (uint256)",
  "function decimals() view returns (uint8)",
  "function symbol() view returns (string)",
];

export const ROUTER_ABI = [
  "function getAmountsOut(uint256 amountIn, address[] calldata path) view returns (uint256[] memory amounts)",
  "function swapExactETHForTokens(uint256 amountOutMin, address[] calldata path, address to, uint256 deadline) payable returns (uint256[] memory amounts)",
];

export function injected() {
  if (!window.ethereum) {
    throw new Error("Nessun wallet rilevato. Apri il sito con MetaMask o nel browser di Trust Wallet.");
  }
  return window.ethereum;
}

export const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

// Resolve the EIP-1193 provider for a specific wallet, handling multi-wallet injection.
export function getInjected(kind) {
  const eth = window.ethereum;
  const list = (eth && eth.providers) ? eth.providers : (eth ? [eth] : []);
  if (kind === "metamask") {
    return list.find((p) => p.isMetaMask && !p.isTrust) || (eth && eth.isMetaMask && !eth.isTrust ? eth : null);
  }
  if (kind === "trust") {
    return window.trustwallet || list.find((p) => p.isTrust) || (eth && eth.isTrust ? eth : null);
  }
  return eth || null;
}

// Deep links to open this dApp inside a mobile wallet's in-app browser.
export function walletDeepLink(kind) {
  const host = window.location.host + window.location.pathname + window.location.search;
  if (kind === "metamask") return `https://metamask.app.link/dapp/${host}`;
  if (kind === "trust") return `https://link.trustwallet.com/open_url?coin_id=20000714&url=${encodeURIComponent(window.location.href)}`;
  return null;
}

export const WALLET_INSTALL = {
  metamask: "https://metamask.io/download/",
  trust: "https://trustwallet.com/download",
};

export async function ensureBsc(eip) {
  const p = eip || injected();
  try {
    await p.request({ method: "wallet_switchEthereumChain", params: [{ chainId: CHAIN_HEX }] });
  } catch (e) {
    if (e.code !== 4902) throw e;
    await p.request({
      method: "wallet_addEthereumChain",
      params: [{
        chainId: CHAIN_HEX,
        chainName: "BNB Smart Chain Mainnet",
        nativeCurrency: { name: "BNB", symbol: "BNB", decimals: 18 },
        rpcUrls: ["https://bsc-dataseed.bnbchain.org"],
        blockExplorerUrls: ["https://bscscan.com"],
      }],
    });
  }
}

export function readProvider(rpc) {
  return new ethers.JsonRpcProvider(rpc || "https://bsc-dataseed.bnbchain.org", 56);
}

export function walletProvider(eip) {
  return new ethers.BrowserProvider(eip || injected(), 56);
}

export const shortAddr = (a) => (a ? `${a.slice(0, 6)}…${a.slice(-4)}` : "");
